export default (function (Sentry) { return function () { return function (next) { return function (action) {
    Sentry.addBreadcrumb({
        category: 'redux',
        message: action.type,
    });
    return next(action);
}; }; }; });
//# sourceMappingURL=reduxMiddleware.js.map